import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useCart } from '../contexts/CartContext';
import homeIcon from '../assets/icons/nav/home.svg';
import searchIcon from '../assets/icons/nav/search.svg';
import cartIcon from '../assets/icons/nav/cart.svg';
import historyIcon from '../assets/icons/nav/history.svg';
import settingsIcon from '../assets/icons/nav/account.svg';

function NavGlyph({ src }) {
  return (
    <span
      className="mobile-bottom-nav__glyph"
      style={{
        WebkitMaskImage: `url(${src})`,
        maskImage: `url(${src})`,
      }}
      aria-hidden
    />
  );
}

export default function MobileBottomNav() {
  const location = useLocation();
  const { getTotalItems, setIsDrawerOpen } = useCart();
  const cartCount = getTotalItems();
  const [signedIn, setSignedIn] = useState(false);

  useEffect(() => {
    const sync = () => setSignedIn(!!sessionStorage.getItem('gbx_data'));
    sync();
    window.addEventListener('authStateChanged', sync);
    window.addEventListener('gbx_authStateChanged', sync);
    return () => {
      window.removeEventListener('authStateChanged', sync);
      window.removeEventListener('gbx_authStateChanged', sync);
    };
  }, []);

  const hideOn = ['/checkout', '/thankyou', '/fail', '/subscribe', '/subscribe-login'];
  if (hideOn.some((p) => location.pathname === p || location.pathname.startsWith('/subscribe/'))) {
    return null;
  }

  const historyActive = location.pathname.startsWith('/profile/history');
  const settingsActive =
    location.pathname === '/settings' || location.pathname.startsWith('/profile/settings');

  const tabs = [
    { key: 'home', to: '/', label: 'Home', icon: homeIcon, end: true },
    { key: 'search', to: '/products', label: 'Search', icon: searchIcon },
    { key: 'cart', to: '/cart', label: 'Cart', icon: cartIcon, cart: true },
    ...(signedIn
      ? [{ key: 'history', to: '/profile/history', label: 'History', icon: historyIcon, history: true }]
      : []),
    { key: 'settings', to: '/settings', label: 'Settings', icon: settingsIcon, settings: true },
  ];

  return (
    <nav className="mobile-bottom-nav d-lg-none" aria-label="Primary">
      <ul className="mobile-bottom-nav__list">
        {tabs.map((tab) => {
          if (tab.cart) {
            const active = location.pathname === '/cart';
            return (
              <li key={tab.key} className="mobile-bottom-nav__slot">
                <button
                  type="button"
                  className={`mobile-bottom-nav__item${active ? ' is-active' : ''}`}
                  onClick={() => setIsDrawerOpen(true)}
                  aria-label={`Cart${cartCount ? `, ${cartCount} items` : ''}`}
                  aria-current={active ? 'page' : undefined}
                >
                  <span className="mobile-bottom-nav__icon-wrap">
                    <NavGlyph src={tab.icon} />
                    {cartCount > 0 && (
                      <span className="mobile-bottom-nav__badge">
                        {cartCount > 99 ? '99+' : cartCount}
                      </span>
                    )}
                  </span>
                </button>
              </li>
            );
          }

          if (tab.history) {
            return (
              <li key={tab.key} className="mobile-bottom-nav__slot">
                <NavLink
                  to={tab.to}
                  className={`mobile-bottom-nav__item${historyActive ? ' is-active' : ''}`}
                  aria-label={tab.label}
                  aria-current={historyActive ? 'page' : undefined}
                >
                  <span className="mobile-bottom-nav__icon-wrap">
                    <NavGlyph src={tab.icon} />
                  </span>
                </NavLink>
              </li>
            );
          }

          if (tab.settings) {
            return (
              <li key={tab.key} className="mobile-bottom-nav__slot">
                <NavLink
                  to={tab.to}
                  className={`mobile-bottom-nav__item${settingsActive ? ' is-active' : ''}`}
                  aria-label={tab.label}
                  aria-current={settingsActive ? 'page' : undefined}
                >
                  <span className="mobile-bottom-nav__icon-wrap">
                    <NavGlyph src={tab.icon} />
                  </span>
                </NavLink>
              </li>
            );
          }

          const productsActive =
            tab.to === '/products' && location.pathname.startsWith('/products');

          return (
            <li key={tab.key} className="mobile-bottom-nav__slot">
              <NavLink
                to={tab.to}
                end={tab.end}
                aria-label={tab.label}
                className={({ isActive }) =>
                  `mobile-bottom-nav__item${isActive || productsActive ? ' is-active' : ''}`
                }
              >
                <span className="mobile-bottom-nav__icon-wrap">
                  <NavGlyph src={tab.icon} />
                </span>
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
